/* eslint-disable import/prefer-default-export */
export const ICONS = {
  ENVELOPE: 'envelope',
  PHONE: 'phone',
  ADDRESS: 'address',
  USER_PLUS: 'user-plus',
  SCAN: 'scan',
  INTERNATIONAL: 'international',
  USA: 'usa',
  CHECK: 'check',
  KEY: 'key',
  SHIELD: 'shield',
  CLIPBOARD: 'clipboard',
  FITLER: 'filter',
  FILLED_FILTER: 'filled_filter',
  CALENDAR: 'calendar',
  FILLED_CALENDAR: 'filled_calendar',
  CRYPTODRAFT: 'cryptodraft',
  USER_SETTINGS: 'user_settings',
  USER_PROFILE: 'user_profile',
  QUESTION_MARK: 'question_mark',
  USER_CIRCLE: 'user_circle',
  USER_ACCOUNT: 'user_account',
  SECURITY_SHIELD: 'security_shield',
  SHOP: 'shop',
  LOGOUT: 'logout',
  EXCHANGE: 'exchange',
  AT_SYMBOL: 'at_symbol',
  PAPER: 'paper',
  STAR: 'star',
  LOADING: 'loading',
  TWITTER: 'twitter',
  SETTING: 'setting',
  WALLET: 'wallet',
  OUTLINE_CARD: 'outline_card',
  SWITCH: 'switch',
  REDIRECT_MARK: 'redirect_mark',
  REFRESH: 'refresh',
  LIGHT: 'light',
  CARD_NOTE: 'card_note',
  SNOW: 'snow',
  RIGHT_ARROW: 'right_arrow',
  GLOBE_LANG: 'globe_lang',
  CIRCLE_PLUS: 'circle_plus',
  CIRCLE_MINUS: 'circle_minus',
  CONNECT: 'connect',
};

export const MAIN_ICON_COLORS = {
  INFO: '#8b80db',
  SHADOW: '#717070',
  DANGER: '#f04f52',
  PRIMARY: '#FF7533',
  WHITE: '#FFFFFF',
  SUCCESS: '#6ec85c',
  GRAY_LIGHT: '#191919',
  GRAY_LIGHTER: '#272727',
};
